<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
    <div class="flex flex-row items-center">
        <h2 mat-dialog-title class="!pl-0 text-2xl !m-0 font-bold !text-red">{{this._data.heading}}</h2>
    </div>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center"
        (click)="this._matDialogRef.close()">
        <mat-icon class="text-orange-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
    <div class="w-full">
        <p *ngIf="this._data.message" class="text-lg leading-5 text-input-color font-medium">{{this._data.message |
            titlecase}}</p>
        <div *ngIf="this._data.htmlContent" [innerHTML]="this._data.htmlContent"></div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="mt-2 !pb-5 !px-0" align="end">
    <div class="flex gap-2 w-full" [ngClass]="'justify-' + this._data.action.align">
        <button color="primary" *ngIf="this._data.action.cancel" (click)="this._matDialogRef.close()"
            class="!bg-blue-theme-color !px-6 !h-11 text-white-color ml-auto mr-0"
            mat-flat-button>{{this._data.action.cancel}}</button>
        <button color="primary" (click)="this._matDialogRef.close(true)"
            class="!bg-blue-theme-color !px-6 !h-11 text-white-color ml-auto mr-0"
            mat-flat-button>{{this._data.action.ok}}</button>
    </div>
</mat-dialog-actions>